// source: icc.search.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.toObject = function(includeInstance, msg) {
  var f, obj = {
dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.toObject, includeInstance),
pagination: (f = msg.getPagination()) && proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.toObject(includeInstance, f),
parameters: (f = msg.getParameters()) && proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.deserializeBinaryFromReader);
      msg.setParameters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.serializeBinaryToWriter
    );
  }
  f = message.getParameters();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SearchData data = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData>}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.prototype.getDataList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData>} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Pagination pagination = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.prototype.getPagination = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SearchParameters parameters = 3;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.prototype.getParameters = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters, 3));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.prototype.setParameters = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.prototype.clearParameters = function() {
  return this.setParameters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchResult.prototype.hasParameters = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
documentId: jspb.Message.getFieldWithDefault(msg, 2, 0),
sku: jspb.Message.getFieldWithDefault(msg, 3, ""),
displayTitle: jspb.Message.getFieldWithDefault(msg, 4, ""),
subtitle: jspb.Message.getFieldWithDefault(msg, 5, ""),
printVersion: jspb.Message.getFieldWithDefault(msg, 6, ""),
printVersionMonth: jspb.Message.getFieldWithDefault(msg, 7, ""),
printVersionYear: (f = msg.getPrintVersionYear()) && proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear.toObject(includeInstance, f),
printVersionEdition: (f = msg.getPrintVersionEdition()) && proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition.toObject(includeInstance, f),
isXml: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
isAstm: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
isPremiumPdf: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
isCollection: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
subscriptionRequired: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
imageUrl: jspb.Message.getFieldWithDefault(msg, 15, ""),
link: jspb.Message.getFieldWithDefault(msg, 16, ""),
supportsVersions: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
isExcluded: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
astmSubject: jspb.Message.getFieldWithDefault(msg, 19, ""),
recentlyAdded: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
contentAccessLevelId: jspb.Message.getFieldWithDefault(msg, 21, 0),
effectiveDate: jspb.Message.getFieldWithDefault(msg, 22, ""),
customCodeProfileLabel: jspb.Message.getFieldWithDefault(msg, 23, ""),
baseCodeInfo: (f = msg.getBaseCodeInfo()) && proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.toObject(includeInstance, f),
titleTopic: (f = msg.getTitleTopic()) && proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.toObject(includeInstance, f),
isMasterBook: jspb.Message.getBooleanFieldWithDefault(msg, 26, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDocumentId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSku(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubtitle(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrintVersion(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrintVersionMonth(value);
      break;
    case 8:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear.deserializeBinaryFromReader);
      msg.setPrintVersionYear(value);
      break;
    case 9:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition.deserializeBinaryFromReader);
      msg.setPrintVersionEdition(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsXml(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAstm(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPremiumPdf(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCollection(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSubscriptionRequired(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setLink(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSupportsVersions(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsExcluded(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setAstmSubject(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRecentlyAdded(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentAccessLevelId(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setEffectiveDate(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomCodeProfileLabel(value);
      break;
    case 24:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.deserializeBinaryFromReader);
      msg.setBaseCodeInfo(value);
      break;
    case 25:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.deserializeBinaryFromReader);
      msg.setTitleTopic(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMasterBook(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDocumentId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSku();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDisplayTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSubtitle();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPrintVersion();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPrintVersionMonth();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPrintVersionYear();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear.serializeBinaryToWriter
    );
  }
  f = message.getPrintVersionEdition();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition.serializeBinaryToWriter
    );
  }
  f = message.getIsXml();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getIsAstm();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getIsPremiumPdf();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getIsCollection();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getSubscriptionRequired();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getLink();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getSupportsVersions();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getIsExcluded();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getAstmSubject();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getRecentlyAdded();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getContentAccessLevelId();
  if (f !== 0) {
    writer.writeInt32(
      21,
      f
    );
  }
  f = message.getEffectiveDate();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getCustomCodeProfileLabel();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getBaseCodeInfo();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.serializeBinaryToWriter
    );
  }
  f = message.getTitleTopic();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.serializeBinaryToWriter
    );
  }
  f = message.getIsMasterBook();
  if (f) {
    writer.writeBool(
      26,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 document_id = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getDocumentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setDocumentId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string sku = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getSku = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setSku = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string display_title = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getDisplayTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setDisplayTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string subtitle = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getSubtitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setSubtitle = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string print_version = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getPrintVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setPrintVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string print_version_month = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getPrintVersionMonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setPrintVersionMonth = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional PrintVersionYear print_version_year = 8;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getPrintVersionYear = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear, 8));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setPrintVersionYear = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.clearPrintVersionYear = function() {
  return this.setPrintVersionYear(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.hasPrintVersionYear = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional PrintVersionEdition print_version_edition = 9;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getPrintVersionEdition = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition, 9));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setPrintVersionEdition = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.clearPrintVersionEdition = function() {
  return this.setPrintVersionEdition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.hasPrintVersionEdition = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool is_xml = 10;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getIsXml = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setIsXml = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool is_astm = 11;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getIsAstm = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setIsAstm = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool is_premium_pdf = 12;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getIsPremiumPdf = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setIsPremiumPdf = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool is_collection = 13;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getIsCollection = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setIsCollection = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool subscription_required = 14;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getSubscriptionRequired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setSubscriptionRequired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional string image_url = 15;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string link = 16;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setLink = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional bool supports_versions = 17;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getSupportsVersions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setSupportsVersions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * optional bool is_excluded = 18;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getIsExcluded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setIsExcluded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * optional string astm_subject = 19;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getAstmSubject = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setAstmSubject = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional bool recently_added = 20;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getRecentlyAdded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setRecentlyAdded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional int32 content_access_level_id = 21;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getContentAccessLevelId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setContentAccessLevelId = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional string effective_date = 22;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getEffectiveDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setEffectiveDate = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string custom_code_profile_label = 23;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getCustomCodeProfileLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setCustomCodeProfileLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional BaseCodeInfo base_code_info = 24;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getBaseCodeInfo = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo, 24));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setBaseCodeInfo = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.clearBaseCodeInfo = function() {
  return this.setBaseCodeInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.hasBaseCodeInfo = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional TitleTopic title_topic = 25;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getTitleTopic = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic, 25));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setTitleTopic = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.clearTitleTopic = function() {
  return this.setTitleTopic(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.hasTitleTopic = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional bool is_master_book = 26;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.getIsMasterBook = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchData.prototype.setIsMasterBook = function(value) {
  return jspb.Message.setProto3BooleanField(this, 26, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
year: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYear(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getYear();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 year = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear.prototype.getYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear.prototype.setYear = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
version: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string version = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
documentSlug: jspb.Message.getFieldWithDefault(msg, 1, ""),
shortTitle: jspb.Message.getFieldWithDefault(msg, 2, ""),
year: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentSlug(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setYear(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentSlug();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getShortTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getYear();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string document_slug = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.prototype.getDocumentSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.prototype.setDocumentSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string short_title = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.prototype.getShortTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.prototype.setShortTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string year = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.prototype.getYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BaseCodeInfo.prototype.setYear = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
iconColor: jspb.Message.getFieldWithDefault(msg, 3, ""),
icon: jspb.Message.getFieldWithDefault(msg, 4, ""),
backgroundColor: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIconColor(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIcon(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBackgroundColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIconColor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIcon();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBackgroundColor();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string icon_color = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.prototype.getIconColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.prototype.setIconColor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string icon = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.prototype.getIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.prototype.setIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string background_color = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.prototype.getBackgroundColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic.prototype.setBackgroundColor = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.toObject = function(includeInstance, msg) {
  var f, obj = {
currentPage: jspb.Message.getFieldWithDefault(msg, 1, 0),
maxPerPage: jspb.Message.getFieldWithDefault(msg, 2, 0),
totalResults: jspb.Message.getFieldWithDefault(msg, 3, 0),
pageStartEnd: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxPerPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalResults(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageStartEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrentPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMaxPerPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTotalResults();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPageStartEnd();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int32 current_page = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.prototype.getCurrentPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.prototype.setCurrentPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 max_per_page = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.prototype.getMaxPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.prototype.setMaxPerPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 total_results = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.prototype.getTotalResults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.prototype.setTotalResults = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string page_start_end = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.prototype.getPageStartEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Pagination.prototype.setPageStartEnd = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.repeatedFields_ = [1,2,3,4,7,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.toObject = function(includeInstance, msg) {
  var f, obj = {
yearList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
typeList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
categoryList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
categoryAndList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
astmSubject: jspb.Message.getFieldWithDefault(msg, 5, ""),
collectionOrPremiumCompleteOnly: jspb.Message.getFieldWithDefault(msg, 6, ""),
formatList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
search: jspb.Message.getFieldWithDefault(msg, 8, ""),
includePricing: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
considerExcludedIds: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
excludedIdsList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addYear(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addCategory(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addCategoryAnd(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAstmSubject(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCollectionOrPremiumCompleteOnly(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addFormat(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearch(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludePricing(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConsiderExcludedIds(value);
      break;
    case 11:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addExcludedIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getYearList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getTypeList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getCategoryList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getCategoryAndList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getAstmSubject();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCollectionOrPremiumCompleteOnly();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFormatList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getSearch();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIncludePricing();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getConsiderExcludedIds();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getExcludedIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      11,
      f
    );
  }
};


/**
 * repeated string year = 1;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.getYearList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.setYearList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.addYear = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.clearYearList = function() {
  return this.setYearList([]);
};


/**
 * repeated string type = 2;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.getTypeList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.setTypeList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.addType = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.clearTypeList = function() {
  return this.setTypeList([]);
};


/**
 * repeated string category = 3;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.getCategoryList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.setCategoryList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.addCategory = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.clearCategoryList = function() {
  return this.setCategoryList([]);
};


/**
 * repeated string category_and = 4;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.getCategoryAndList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.setCategoryAndList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.addCategoryAnd = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.clearCategoryAndList = function() {
  return this.setCategoryAndList([]);
};


/**
 * optional string astm_subject = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.getAstmSubject = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.setAstmSubject = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string collection_or_premium_complete_only = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.getCollectionOrPremiumCompleteOnly = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.setCollectionOrPremiumCompleteOnly = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated string format = 7;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.getFormatList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.setFormatList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.addFormat = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.clearFormatList = function() {
  return this.setFormatList([]);
};


/**
 * optional string search = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.getSearch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.setSearch = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool include_pricing = 9;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.getIncludePricing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.setIncludePricing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool consider_excluded_ids = 10;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.getConsiderExcludedIds = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.setConsiderExcludedIds = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * repeated int32 excluded_ids = 11;
 * @return {!Array<number>}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.getExcludedIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.setExcludedIdsList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.addExcludedIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SearchParameters.prototype.clearExcludedIdsList = function() {
  return this.setExcludedIdsList([]);
};


goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy);
